export function mapValuesToReadonlyArray<T>(map: Map<any, T>) {
    const list: T[] = [];
    map.forEach(value => list.push(value));
    return list as ReadonlyArray<T>;
}

export function uniqueValuesArrayFilter<T>(value: T, index: number, array: T[]): boolean {
    return array.indexOf(value) === index;
}
